import algoliasearch from 'algoliasearch'
import { ALGOLIA_APP_ID } from './algoliaPublicClient'

export const createAlgoliaSecuredKeyClient = (securedKey: string) =>
  algoliasearch(ALGOLIA_APP_ID, securedKey)
